import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/clinical")({
  head: () => buildRouteHead("/clinical", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/services/clinical-solutions", replace: true });
  },
});
